import React from 'react';
import { connect } from 'react-redux';

import GreetlyVouchers from './GreetlyVouchers';
import { PageHeader } from '../../components';
import { getGreetlyMerchant } from '../../constants/greetlyPortal';
import { ROLE_SUB_MERCHANT_ADMINISTRATOR } from '../../constants/roles';

// Greetly page for merchant / sub merchant administrators. The store filter is
// pinned to their own merchant and, for a sub merchant administrator, the
// location is pinned to their own outlet. The backend scopes the results to the
// merchants on the logged-in user regardless, so this only fixes what the page
// shows.
const MerchantGreetlyVouchers = (props) => {
    const { role, currentUser } = props.user;
    const merchant = getGreetlyMerchant(props.user);
    // The user slice holds the sub merchant, but fall back to the raw user
    // details so a missing location can't silently widen the list.
    const location =
        role === ROLE_SUB_MERCHANT_ADMINISTRATOR
            ? currentUser?.location ||
              props.auth?.details?.coreSubMerchantAdmin?.location
            : undefined;

    if (!merchant || !merchant.name) {
        return <PageHeader text='Greetly Vouchers' />;
    }

    return (
        <GreetlyVouchers
            pageTitle='Greetly Vouchers'
            storeFilter={merchant.name}
            locationFilter={location}
            tableVariant='merchant'
        />
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.user,
        auth: state.auth.auth,
    };
};

export default connect(mapStateToProps)(MerchantGreetlyVouchers);
